import ImportRecordsModal from "@/components/ImportRecordsModal";

// Fields the importer can map to. `company` is required.
const FIELDS = [
  { key: "sourced_from", label: "Sourced From" },
  { key: "_blank", label: "—" },
  { key: "company", label: "Company", required: true },
  { key: "contact", label: "Contact Person" },
  { key: "country", label: "Country" },
  { key: "city_or_state", label: "City / State" },
  { key: "requirement", label: "Requirement" },
  { key: "quality", label: "Quality" },
  { key: "phones", label: "Phones (; or , separated)" },
  { key: "emails", label: "Emails (; or , separated)" },
  { key: "address", label: "Address" },
  { key: "website", label: "Website" },
  { key: "customer_since", label: "Customer Since (YYYY-MM-DD)" },
  { key: "rating", label: "Rating (0–5)" },
  { key: "notes", label: "Notes" },
  { key: "sales_person_name", label: "Sales Person (name)" },
  { key: "sales_person_email", label: "Sales Person (email — links to user)" },
];

export default function ImportCustomersModal({ onClose, onImported }) {
  return (
    <ImportRecordsModal
      onClose={onClose}
      onImported={onImported}
      title="Import Customers"
      subtitle="Upload a CSV and map columns to fields"
      endpoint="/customers/import"
      fields={FIELDS}
      entitySingular="customer"
      entityPlural="customers"
      failedFileName="failed_customers.csv"
    />
  );
}
